<template>
  <apartment-blank-form
    submit-label="Сохранить"
    v-bind="$attrs"
    form-type="edit"
    :errors="errors"
    @submit="processApartmentForm"
  />
</template>

<script>
import helpers from '@/helpers'
import { updateApartment } from '@/services/apartment.service'
import apartmentBlankForm from '@/components/forms/apartment/ApartmentBlankForm'

export default {
  name: 'apartment-edit-form',
  components: { apartmentBlankForm },
  inheritAttrs: false,
  data () {
    return {
      errors: {
        apartment: {
          id: [],
          number: [],
          block: []
        },
        non_field_errors: []
      }
    }
  },
  methods: {
    fillErrors: helpers.fillErrors,

    processApartmentForm () {
      this.updateApartment().then((success) => {
        if (success) {
          this.showMsg('Информация о квартире была успешно обновлена!', 'success', 'Успешно')
          this.$emit('after', true)
        } else {
          this.$emit('after', false)
        }
      })
    },
    updateApartment () {
      return updateApartment(this.$attrs.apartment).then((response) => {
        this.fillErrors(this.errors.apartment, {})
        return true
      }).catch(err => {
        this.fillErrors(this.errors.apartment, err.response.data)

        if (this.errors.non_field_errors[0]) {
          this.$parent.$parent.showPopupMsg(this.errors.non_field_errors[0], 'error')
        }

        return false
      })
    },
    showMsg (text, type, title) {
      let foundRoot = false
      let $parent = this.$parent

      while (!foundRoot) {
        console.log($parent)
        if ($parent.$parent.$parent === undefined) {
          foundRoot = true
          $parent.showPopupMsg(text, type, title)
        } else {
          $parent = $parent.$parent
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// ApartmentEditForm.vue?113ca9bc